import { useEffect, useRef } from 'react';

export const useButtonsGroupAnimation = () => {
  const groupRef = useRef<HTMLDivElement>(null);
  const indicatorRef = useRef<HTMLDivElement>(null);

  const updateIndicator = () => {
    const group = groupRef.current;
    const indicator = indicatorRef.current;

    if (!group || !indicator) return;

    const activeButton = group.querySelector(
      '[data-active="true"]'
    ) as HTMLButtonElement;

    if (activeButton) {
      indicator.style.width = `${activeButton.offsetWidth}px`;
      indicator.style.left = `${activeButton.offsetLeft}px`;
    }
  };

  useEffect(() => {
    const group = groupRef.current;
    if (!group) return;

    const observer = new MutationObserver(updateIndicator);
    observer.observe(group, {
      attributes: true,
      subtree: true,
      attributeFilter: ['data-active'],
    });

    const resizeObserver = new ResizeObserver(updateIndicator);
    resizeObserver.observe(group);

    updateIndicator();

    return () => {
      observer.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return {
    groupRef,
    indicatorRef,
  };
};
